import routes from './routes'
import { LobbyEntryProps, LobbyEntryTypes } from './components/LobbyEntry/LobbyEntry'

// backdrops
import Entrance from './images/backdrops/entrance.jpg'
import EntranceM from './images/backdrops/registerM.jpg'
import Register from './images/backdrops/register.jpg'
import Countdown from './images/backdrops/countdown.jpg'
import CountdownM from './images/backdrops/countdownM.jpg'
import LobbyL from './images/backdrops/lobby.jpg'
import LobbyM from './images/backdrops/space.jpg'
import Exhibition from './images/backdrops/exhibition.jpg'
import Auditorium from './images/backdrops/auditorium.jpg'
import NetworkingL from './images/backdrops/networking.jpg'
import NetworkingM from './images/backdrops/networkingM.jpg'
import Gallerium from './images/backdrops/gallerium.jpg'
import TikTokM from './images/backdrops/votingM.jpg'
import Voting from './images/backdrops/voting-plain.jpg'

// audio
import LobbyMusic from './images/audio/lobby.mp3'

// icons & decorations
import TiktokIcon from './images/lobbyEntry/tiktok.png'
import InfoIcon from './images/lobbyEntry/infoIcon.png'
import PinIcon from './images/lobbyEntry/pinIcon.png'
import { GlobalModalTypes } from './components/GlobalModals/GlobalModalContainer'

const dev = {
  // apiUrl: 'http://localhost:3000',
  apiUrl: 'https://ceodayatutp2021.herokuapp.com',
}

const prod = {
  apiUrl: 'https://ceodayatutp2021.herokuapp.com',
}

const API_KEYS = {
  amplitude: '89ad9bba924caecd2d529fb6b9cae44e',
}

const VOLUME_VALUE = 1

// Root page will show either EntrancePage or CountdownPage
// based on the following time setting
const EVENT_START_TIME = {
  year: 2021,
  month: 10,
  day: 18,
  hour: 8,
  minute: 0,
}

const config = process.env.NODE_ENV === 'production' ? prod : dev

const assets = {
  entrance: {
    landscape: Entrance,
    portrait: EntranceM,
  },
  register: {
    landscape: Register,
    portrait: Register,
  },
  countdown: {
    landscape: Countdown,
    portrait: CountdownM,
  },
  lobby: {
    landscape: LobbyL,
    portrait: LobbyM,
  },
  auditorium1: {
    landscape: Auditorium,
    portrait: EntranceM,
  },
  tiktok: {
    landscape: Voting,
    portrait: TikTokM,
  },

  exhibition1: Exhibition,
  exhibition2: Exhibition,

  networking: {
    landscape: NetworkingL,
    portrait: NetworkingM,
  },
  gallerium: Gallerium,

  lobbyMusic: LobbyMusic,
}

const layout = {
  auditoriumVid: `
    top: 25%;
    bottom: 23%;
    left: 15%;
    right: 34%;
  `,
}

const lobbyEntries: Array<LobbyEntryProps & { id: string }> = [
  {
    id: 'auditorium',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.auditorium1,
    pinImage: PinIcon,
    css: `
      top: 25%;
      left: 68.5%;
      right: 12.5%;
      bottom: 65.6%;
    `,
  },
  {
    id: 'exhibition',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.exhibition1,
    pinImage: PinIcon,
    css: `
      top: 41.5%;
      left: 68.5%;
      right: 12.5%;
      bottom: 48.9%;
    `,
  },
  {
    id: 'virtual-tour',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.virtual,
    pinImage: PinIcon,
    css: `
      top: 30.8%;
      left: 8.5%;
      right: 73%;
      bottom: 59.5%;
    `,
  },
  {
    id: 'helpdesk',
    type: LobbyEntryTypes.Helpdesk,
    entryOpenImage: InfoIcon,
    entryCloseImage: InfoIcon,
    css: `
      top: 69%;
      left: 82%;
      right: 8%;
      bottom: 12%;
    `,
  },
  {
    id: 'tiktok',
    type: LobbyEntryTypes.GlobalModal,
    modalId: GlobalModalTypes.TikTok,
    entryOpenImage: TiktokIcon,
    entryCloseImage: TiktokIcon,
    css: `
      top: 69%;
      left: 8%;
      right: 82%;
      bottom: 12%;
    `,
  },
  {
    id: 'agenda-modal',
    type: LobbyEntryTypes.GlobalModal,
    modalId: GlobalModalTypes.Agenda,
    pinImage: PinIcon,
    css: `
      top: 14.4%;
      left: 8.5%;
      right: 73%;
      bottom: 76%;
    `,
  },
  {
    id: 'game-modal',
    type: LobbyEntryTypes.GlobalModal,
    modalId: GlobalModalTypes.Game,
    pinImage: PinIcon,
    css: `
      top: 35.5%;
      left: 28.5%;
      right: 63.5%;
      bottom: 36%;
    `,
  },
]

export default {
  API_KEYS,
  assets,
  layout,
  lobbyEntries,
  VOLUME_VALUE,
  EVENT_START_TIME,

  eventName: 'CEO DAY @ UTP 2021',

  ...config,
}
